jQuery(function($){
var ellipsestext = "..";
	 if ( $('#shopify-section-template--21353883664723__rich_text_8qMBqy .section-blocks__text p:first-child').length ) {

      if ($('#shopify-section-template--21353883664723__rich_text_8qMBqy .section-blocks__text').height() > 200 ) {
  		$( "<div class='showMore'>Rodyti daugiau</div>" ).insertAfter( "#shopify-section-template--21353883664723__rich_text_8qMBqy .section-blocks__text" );
  		$(window).resize(function() {
      		var height = $("#shopify-section-template--21353883664723__rich_text_8qMBqy .section-blocks__text p:first-of-type").height();
      		$("#shopify-section-template--21353883664723__rich_text_8qMBqy .section-blocks__text").css("height", height + 10 );
  		}).resize();
    		$("#shopify-section-template--21353883664723__rich_text_8qMBqy .section-blocks__text p:first-of-type").append("<span class='ellipseTxt'>" + ellipsestext + "</span>");
		}
    }

$(".showMore").on("click", function(){
		var $btn = $(".showMore");
		var $content = $("#shopify-section-template--21353883664723__rich_text_8qMBqy .section-blocks__text");
		$content.toggleClass("sized");

		if(($('#shopify-section-template--21353883664723__rich_text_8qMBqy .section-blocks__text.sized').length)){
    		$btn.text("Rodyti mažiau");
            $( "span" ).remove( ".ellipseTxt" );
		} else {
        	$btn.text("Rodyti daugiau");
          $("#shopify-section-template--21353883664723__rich_text_8qMBqy .section-blocks__text p:first-of-type").append("<span class='ellipseTxt'>" + ellipsestext + "</span>");
		}
});
});